import TextField, { TextFieldProps } from '@material-ui/core/TextField'
import debounce from 'lodash/debounce'
import React, { useEffect, useState } from 'react'

interface IProps {
  onFinalChange: (value: string) => void
  timeToWait: number
}

export const DebouncedTextField = ({ timeToWait, onFinalChange, ...props }: IProps & TextFieldProps) => {
  // We set the default value with the given props to display the value
  // in the search bar at the initialization
  const [buffer, setBuffer] = useState<string>(props.value as string)

  useEffect(() => setBuffer(props.value as string), [props.value])

  const debouncedUpdate = debounce((value: string) => onFinalChange(value), timeToWait)

  useEffect(() => {
    if (buffer !== (props.value as string)) {
      debouncedUpdate(buffer)
      return debouncedUpdate.cancel
    }
  }, [buffer])

  const myOnChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    setBuffer(evt.target.value)
  }

  return <TextField {...props} value={buffer} onChange={myOnChange} />
}
